import React, { useEffect, useRef, useState } from 'react';
import TMC from '@autonomic/browser-sdk';
import ConfirmationDialog from '@au/core/lib/components/objects/ConfirmationDialog';
import Spinner from '@au/core/lib/components/elements/Spinner';
import moment from 'moment-timezone';
import { createResponseAlertMessage } from '@au/core/lib/components/objects/AlertMessage';
import styles from '../css/components/sync_rule_detail_dialog.module.scss';

const TZ = moment.tz.guess();

const formatDate = (value) => {
  if (!value) return '';
  return moment.tz(value, TZ).format('MMM DD YYYY hh:mm a z');
};

const SyncRuleDetailsDialog = ({ sourceEnv, sourceLiveId, onClose }) => {
  const [conversionRule, setConversionRule] = useState();
  const [fetching, setFetching] = useState(true);

  const endpointRef = useRef(null);
  if (endpointRef.current === null) {
    endpointRef.current = new TMC.services.TelemetryDefinition().syncConfigs;
  }

  useEffect(() => {
    let cancelled = false;
    endpointRef.current
      .getRuleById(sourceEnv, sourceLiveId)
      .then((resp) => {
        if (!cancelled) setConversionRule(resp.data);
        setFetching(false);
      })
      .catch((err) => {
        createResponseAlertMessage(err);
        setFetching(false);
      });

    return () => {
      cancelled = true;
    };
  }, [sourceEnv, sourceLiveId]);

  return (
    <ConfirmationDialog
      headerClassName={styles.header}
      bodyClassName={styles.body}
      titleId={'au.entity.attr.conversionRule'}
      confirmDisplayId={'au.entity.close'}
      showCancelButton={false}
      onConfirm={onClose}
      onCancel={onClose}
    >
      <div className={styles.subheader}>
        {fetching ? (
          <Spinner className={styles.spinner} />
        ) : (
          <>
            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Id:</span>
              <span className={styles.subheader_value}>{conversionRule?.id}</span>
            </div>

            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Source Message Name:</span>
              <span className={styles.subheader_value}>{conversionRule?.sourceMessageName}</span>
            </div>

            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Release Stage Name:</span>
              <span className={styles.subheader_value}>{conversionRule?.releaseStageName}</span>
            </div>

            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Source Scheme:</span>
              <span className={styles.subheader_value}>{conversionRule?.sourceScheme}</span>
            </div>

            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Target Scheme:</span>
              <span className={styles.subheader_value}>{conversionRule?.targetScheme}</span>
            </div>

            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Create Time:</span>
              <span className={styles.subheader_value}>{formatDate(conversionRule?.inceptionTime)}</span>
            </div>

            <div className={styles.subheader_item}>
              <span className={styles.subheader_title}>Update Time:</span>
              <span className={styles.subheader_value}>{formatDate(conversionRule?.lastModifiedTime)}</span>
            </div>
          </>
        )}
      </div>
    </ConfirmationDialog>
  );
};

export default SyncRuleDetailsDialog;
